import React, { useState, useEffect, useMemo } from "react";
import {
    Button, Box, Typography, Grid, TextField, Autocomplete, FormHelperText,
    Dialog, DialogTitle, DialogActions, DialogContent, IconButton
} from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import moment from "moment/moment";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import { RxCross2 } from "react-icons/rx";
import { useEditProcurementHotelSitcMutation } from "store/slices/apis/procurementHotelSitcSlice";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
import { mapAndSortAlphabetically } from "utils/mapSortHelper";
import { useGetAllContactsQuery } from "store/slices/apis/contactSlice";
import { usePermission } from "hooks/usePermission";

const rightLabelStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
};

const rightTextStyle = {
    "& .MuiInputBase-input": {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "100%",
        letterSpacing: "0.16px",
        color: "#0A0A0C",
        fontFamily: "Outfit, sans-serif",
    },
};

const labelTextStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
    mb: 1,
    mt: 1,
};

const commonInputFieldStyle = {
    sx: {
        height: "40px",
        borderRadius: "4px",
        backgroundColor: "#fff",
        "& input::placeholder": {
            fontWeight: 400,
            fontSize: "16px",
            lineHeight: "100%",
            letterSpacing: "0.16px",
            color: "#5F5F5F",
            fontFamily: "Outfit, sans-serif",
            opacity: 1,
        },
        "& input": {
            fontWeight: 400,
            fontSize: "16px",
            lineHeight: "100%",
            letterSpacing: "0.16px",
            color: "#0A0A0C",
            fontFamily: "Outfit, sans-serif",
        },
    },
}


const calenderSVG = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_894_610)">
            <path d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z" fill="#433F5E" />
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
            <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
            <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
        </g>
        <defs>
            <clipPath id="clip0_894_610">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const EditHotelSitc = (props) => {
    const { open, handleClose, procurementData, tabKey, subTabValue } = props;
    const { projectId } = useParams();
    const dispatch = useDispatch();
    const [actionResponsible, setActionContact] = useState([])
    const isAdminAccess = usePermission()

    const module = "Procurement"


    const [updateProcurement] = useEditProcurementHotelSitcMutation()

    const { data: ServiceCategoryData } = useGetMasterDataQuery({ module: module, category: 'ServiceCategory', ProjectId: projectId });
    const { data: procurementMethodData } = useGetMasterDataQuery({ module: module, category: 'ProcurementMethod', ProjectId: projectId });
    const { data: SourceDepartmentData } = useGetMasterDataQuery({ module: module, category: 'SourceDepartment', ProjectId: projectId });
    const contactListRes = useGetAllContactsQuery();
    const { data: vendorNameList } = useGetMasterDataQuery({ module: module, category: 'VendorName', ProjectId: projectId });
    const vendorNameOption = useMemo(() => {
        return vendorNameList?.data
            ?.map((item) => ({
                label: item?.value,
                value: item?.value
            }))
            ?.sort((a, b) => a?.label?.localeCompare(b?.label)) || [];
    }, [vendorNameList]);

    const { data: procurementStatusRes } = useGetMasterDataQuery({ module: module, category: 'Status', ProjectId: projectId });
    const procurementStatusData = procurementStatusRes?.data || [];
    const procurementStatusOption = (procurementStatusData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const { data: procurementAdminStatusRes } = useGetMasterDataQuery({ module: module, category: 'AdminStatus', ProjectId: projectId });
    const procurementAdminStatusData = procurementAdminStatusRes?.data || [];
    const procurementAdminStatusOption = (procurementAdminStatusData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const filteredStatusOption = isAdminAccess
        ? procurementAdminStatusOption
        : procurementStatusOption;

    useEffect(() => {
        if (contactListRes?.isSuccess) {
            const contacts = contactListRes?.data?.data || [];
            setActionContact(
                mapAndSortAlphabetically(contacts, "name", "email")
            );
            // setActionContact(
            //     contactListRes?.data?.data?.map(item => ({
            //         value: item?.email,
            //         label: item?.name
            //     }))
            // );
        }
    }, [contactListRes])


    const serviceCategoryOption = ServiceCategoryData?.data.map((item) => ({
        label: item?.value,
        value: item?.value
    })
    )

    const procurementMethodOption = procurementMethodData?.data.map((item) => ({
        label: item?.value,
        value: item?.value
    })
    )

    const SourceDepartmentOption = SourceDepartmentData?.data.map((item) => ({
        label: item?.value,
        value: item?.value
    })
    )



    const [initialFormData, setInitialFormData] = useState({
        subProject: "",
        serviceCategory: "",
        procurementMethod: "",
        sourceDepartment: "",
        procurementOwner: "",
        packageDescription: "",
        scopeSummary: "",
        loiReference: "",
        vendorName: "",
        status: "",
        actualLoiWoDate: "",
        plannedDateOfTenderPackage: "",
        completion: {
            actualDate: "",
            plannedDate: ""
        },
        closeout: {
            actualDate: "",
            plannedDate: ""
        },
        mobilization: {
            actualDate: "",
            plannedDate: "",
            days: null,
        },
        poIssue: {
            actualDate: "",
            plannedDate: "",
            days: null,
        },
        approval: {
            actualDate: "",
            plannedDate: "",
            days: null,
        },
        negotiationAndRecommendation: {
            actualDate: "",
            plannedDate: "",
            days: null,
        },
        commercialEvaluation: {
            actualDate: "",
            plannedDate: "",
            days: null,
        },
        technicalEvaluation: {
            actualDate: "",
            plannedDate: "",
            days: null,
        },
        bidSubmission: {
            actualDate: "",
            plannedDate: "",
            days: null,
        },
        preBidMeeting: {
            actualDate: "",
            plannedDate: "",
            days: null,
        },
        bidInvitation: {
            actualDate: "",
            plannedDate: "",
            days: null,
        },
        nttIssue: {
            actualDate: "",
            plannedDate: "",
            days: null,
        },
        rfpPreparation: {
            actualDate: "",
            plannedDate: "",
            days: null,
        },
        budgetedCost: "",
        actualCost: "",
        // plannedDateForServiceRequest: "",
        actualServiceRequestIndentDate: "",
        // plannedRfpRfqFloatingDate: "",
        // bidReceiptCutoffDate: "",
        // // plannedLoiReleaseDate: "",
        // plannedFinishAtSiteDate: "",
        leadTimedays: null,
        // mobilizationRequiredDaysLeft: "",
        lastUpdatedDate: "",
        status: "",
        remark: "",
    });

    const formatDateForInput = (dateString) => {
        if (!dateString) return "";
        return moment(dateString).format("YYYY-MM-DD");
    };

    useEffect(() => {
        if (procurementData && open) {
            const formattedData = {
                subProject: procurementData.subProject || "",
                serviceCategory: procurementData.serviceCategory || "",
                procurementMethod: procurementData.procurementMethod || "",
                sourceDepartment: procurementData.sourceDepartment || "",
                procurementOwner: procurementData.procurementOwner || "",
                packageDescription: procurementData.packageDescription || "",
                scopeSummary: procurementData.scopeSummary || "",
                vendorName: procurementData.vendorName || "",
                loiReference: procurementData.loiReference || "",
                status: procurementData.status || "",
                plannedDateOfTenderPackage: formatDateForInput(procurementData.plannedDateOfTenderPackage),

                completion: {
                    actualDate: formatDateForInput(procurementData.completionActual),
                    plannedDate: formatDateForInput(procurementData.completionPlanned)
                },
                closeout: {
                    actualDate: formatDateForInput(procurementData.closeoutActual),
                    plannedDate: formatDateForInput(procurementData.closeoutPlanned)
                },
                mobilization: {
                    actualDate: formatDateForInput(procurementData.mobilizationActual),
                    plannedDate: formatDateForInput(procurementData.mobilizationPlanned),
                    days: procurementData.mobilizationDays || null,
                },
                poIssue: {
                    actualDate: formatDateForInput(procurementData.poLoaIssueActual),
                    plannedDate: formatDateForInput(procurementData.poLoaIssuePlanned),
                    days: procurementData.poLoaIssueDays || null,
                },
                approval: {
                    actualDate: formatDateForInput(procurementData.approvalActual),
                    plannedDate: formatDateForInput(procurementData.approvalPlanned),
                    days: procurementData.approvalDays || null,
                },
                negotiationAndRecommendation: {
                    actualDate: formatDateForInput(procurementData.negotiationActual),
                    plannedDate: formatDateForInput(procurementData.negotiationPlanned),
                    days: procurementData.negotiationDays || null,
                },
                commercialEvaluation: {
                    actualDate: formatDateForInput(procurementData.commercialEvaluationActual),
                    plannedDate: formatDateForInput(procurementData.commercialEvaluationPlanned),
                    days: procurementData.commercialEvaluationDays || null,
                },
                technicalEvaluation: {
                    actualDate: formatDateForInput(procurementData.technicalEvaluationActual),
                    plannedDate: formatDateForInput(procurementData.technicalEvaluationPlanned),
                    days: procurementData.technicalEvaluationDays || null,
                },
                bidSubmission: {
                    actualDate: formatDateForInput(procurementData.bidSubmissionActual),
                    plannedDate: formatDateForInput(procurementData.bidSubmissionPlanned),
                    days: procurementData.bidSubmissionDays || null,
                },
                preBidMeeting: {
                    actualDate: formatDateForInput(procurementData.preBidMeetingActual),
                    plannedDate: formatDateForInput(procurementData.preBidMeetingPlanned),
                    days: procurementData.preBidMeetingDays || null,
                },
                bidInvitation: {
                    actualDate: formatDateForInput(procurementData.bidInvitationActual),
                    plannedDate: formatDateForInput(procurementData.bidInvitationPlanned),
                    days: procurementData.bidInvitationDays || null,
                },
                nttIssue: {
                    actualDate: formatDateForInput(procurementData.nitIssueActual),
                    plannedDate: formatDateForInput(procurementData.nitIssuePlanned),
                    days: procurementData.nitIssueDays || null,
                },
                rfpPreparation: {
                    actualDate: formatDateForInput(procurementData.rfpRfqActual),
                    plannedDate: formatDateForInput(procurementData.rfpRfqPlanned),
                    days: procurementData.rfpRfqDays || null,
                },
                budgetedCost: procurementData.budgetedCost || null,
                actualCost: procurementData.actualCost || null,
                actualLoiWoDate: formatDateForInput(procurementData.actualLoiWoDate),
                // plannedDateForServiceRequest: formatDateForInput(procurementData.plannedDateForServiceRequest),
                actualServiceRequestIndentDate: formatDateForInput(procurementData.actualServiceRequestIndentDate),
                // plannedRfpRfqFloatingDate: formatDateForInput(procurementData.plannedRfpRfqFloatingDate),
                // bidReceiptCutoffDate: formatDateForInput(procurementData.bidReceiptCutoffDate),
                // plannedLoiReleaseDate: formatDateForInput(procurementData.plannedLoiReleaseDate),
                // plannedFinishAtSiteDate: formatDateForInput(procurementData.plannedFinishAtSiteDate),
                leadTimeDays: procurementData.leadTimeDays || null,
                // mobilizationRequiredDaysLeft: procurementData.mobilizationRequiredDaysLeft || null,
                lastUpdatedDate: formatDateForInput(procurementData.lastUpdatedDate),
                status: procurementData.status || "",
                remark: procurementData.remark || "",
            };
            setInitialFormData(formattedData);
        }
    }, [procurementData, open]);

    const validationSchema = Yup.object({
        // subProject: Yup.string().required("Sub Project field is required"),
        // serviceCategory: Yup.string().required("Service Category field is required"),
        // procurementMethod: Yup.string().required("Procurement Method field is required"),
        // sourceDepartment: Yup.string().required("Source Department field is required"),
        // procurementOwner: Yup.string().required("Procurement Owner field is required"),
        packageDescription: Yup.string().trim().required("Package Description field is required"),
        status: Yup.string().trim().required("Status is required"),
        mobilization: Yup.object().shape({
            days: Yup.number()
                .min(1, "Days must be greater than 0")
                .nullable()
                .notRequired()
        }),
        poIssue: Yup.object().shape({
            days: Yup.number()
                .min(1, "Days must be greater than 0")
                .nullable()
                .notRequired()
        }),
        approval: Yup.object().shape({
            days: Yup.number()
                .min(1, "Days must be greater than 0")
                .nullable()
                .notRequired()
        }),
        negotiationAndRecommendation: Yup.object().shape({
            days: Yup.number()
                .min(1, "Days must be greater than 0")
                .nullable()
                .notRequired()
        }),
        commercialEvaluation: Yup.object().shape({
            days: Yup.number()
                .min(1, "Days must be greater than 0")
                .nullable()
                .notRequired()
        }),
        technicalEvaluation: Yup.object().shape({
            days: Yup.number()
                .min(1, "Days must be greater than 0")
                .nullable()
                .notRequired()
        }),
        bidSubmission: Yup.object().shape({
            days: Yup.number()
                .min(1, "Days must be greater than 0")
                .nullable()
                .notRequired()
        }),
        preBidMeeting: Yup.object().shape({
            days: Yup.number()
                .min(1, "Days must be greater than 0")
                .nullable()
                .notRequired()
        }),
        bidInvitation: Yup.object().shape({
            days: Yup.number()
                .min(1, "Days must be greater than 0")
                .nullable()
                .notRequired()
        }),
        nttIssue: Yup.object().shape({
            days: Yup.number()
                .min(1, "Days must be greater than 0")
                .nullable()
                .notRequired()
        }),
        rfpPreparation: Yup.object().shape({
            days: Yup.number()
                .min(1, "Days must be greater than 0")
                .nullable()
                .notRequired()
        })
    });

    const handleSitcSubmit = async (values, { setSubmitting, resetForm }) => {
        const formatDate = (dateString) => {
            if (!dateString) return null;
            return moment(dateString).format('YYYY-MM-DDTHH:mm:ss[Z]');
        };

        const safeParseInt = (value) => {
            if (!value && value !== 0) return 0;
            const num = parseInt(value);
            return isNaN(num) ? null : num;
        };

        const safeParseFloat = (value) => {
            if (!value && value !== 0) return 0;
            const num = parseFloat(value);
            return isNaN(num) ? null : num;
        };

        let reqBody = {
            procurementHotelSitcId: procurementData.procurementHotelSitcId,
            slNo: procurementData.slNo || 0,
            srNo: procurementData.srNo || "string",
            projectId: projectId,
            projectName: procurementData.projectName || "string",
            procurementType: procurementData.procurementType || tabKey || "",
            subProject: values?.subProject || "",
            packageDescription: values?.packageDescription || "",
            serviceCategory: values?.serviceCategory || "",
            scopeSummary: values?.scopeSummary || "",
            procurementMethod: values?.procurementMethod || "",
            loiReference: values?.loiReference || "",
            vendorName: values?.vendorName || "",
            actualLoiWoDate: formatDate(values.actualLoiWoDate),
            budgetedCost: safeParseFloat(values?.budgetedCost),
            actualCost: safeParseFloat(values?.actualCost),
            sourceDepartment: values?.sourceDepartment || "",
            procurementOwner: values?.procurementOwner || "",
            // plannedDateForServiceRequest: formatDate(values?.plannedDateForServiceRequest),
            actualServiceRequestIndentDate: formatDate(values?.actualServiceRequestIndentDate),
            // plannedRfpRfqFloatingDate: formatDate(values?.plannedRfpRfqFloatingDate),
            // bidReceiptCutoffDate: formatDate(values?.bidReceiptCutoffDate),
            // plannedLoiReleaseDate: formatDate(values?.plannedLoiReleaseDate),
            // plannedFinishAtSiteDate: formatDate(values?.plannedFinishAtSiteDate),
            leadTimeDays: safeParseInt(values?.leadTimeDays),
            // mobilizationRequiredDaysLeft: safeParseInt(values?.mobilizationRequiredDaysLeft),
            lastUpdatedDate: formatDate(values?.lastUpdatedDate),
            status: values?.status || "",
            remark: values?.remark || "",
            plannedDateOfTenderPackage: formatDate(values.plannedDateOfTenderPackage),

            rfpRfqDays: safeParseInt(values?.rfpPreparation?.days),
            rfpRfqPlanned: formatDate(values?.rfpPreparation?.plannedDate),
            rfpRfqActual: formatDate(values?.rfpPreparation?.actualDate),

            nitIssueDays: safeParseInt(values?.nttIssue?.days),
            nitIssuePlanned: formatDate(values?.nttIssue?.plannedDate),
            nitIssueActual: formatDate(values?.nttIssue?.actualDate),

            bidInvitationDays: safeParseInt(values?.bidInvitation?.days),
            bidInvitationPlanned: formatDate(values?.bidInvitation?.plannedDate),
            bidInvitationActual: formatDate(values?.bidInvitation?.actualDate),

            preBidMeetingDays: safeParseInt(values?.preBidMeeting?.days),
            preBidMeetingPlanned: formatDate(values?.preBidMeeting?.plannedDate),
            preBidMeetingActual: formatDate(values?.preBidMeeting?.actualDate),

            bidSubmissionDays: safeParseInt(values?.bidSubmission?.days),
            bidSubmissionPlanned: formatDate(values?.bidSubmission?.plannedDate),
            bidSubmissionActual: formatDate(values?.bidSubmission?.actualDate),

            technicalEvaluationDays: safeParseInt(values?.technicalEvaluation?.days),
            technicalEvaluationPlanned: formatDate(values?.technicalEvaluation?.plannedDate),
            technicalEvaluationActual: formatDate(values?.technicalEvaluation?.actualDate),

            commercialEvaluationDays: safeParseInt(values?.commercialEvaluation?.days),
            commercialEvaluationPlanned: formatDate(values?.commercialEvaluation?.plannedDate),
            commercialEvaluationActual: formatDate(values?.commercialEvaluation?.actualDate),

            negotiationDays: safeParseInt(values?.negotiationAndRecommendation?.days),
            negotiationPlanned: formatDate(values?.negotiationAndRecommendation?.plannedDate),
            negotiationActual: formatDate(values?.negotiationAndRecommendation?.actualDate),

            approvalDays: safeParseInt(values?.approval?.days),
            approvalPlanned: formatDate(values?.approval?.plannedDate),
            approvalActual: formatDate(values?.approval?.actualDate),

            poLoaIssueDays: safeParseInt(values?.poIssue?.days),
            poLoaIssuePlanned: formatDate(values?.poIssue?.plannedDate),
            poLoaIssueActual: formatDate(values?.poIssue?.actualDate),

            mobilizationDays: safeParseInt(values?.mobilization?.days),
            mobilizationPlanned: formatDate(values?.mobilization?.plannedDate),
            mobilizationActual: formatDate(values?.mobilization?.actualDate),

            completionPlanned: formatDate(values?.completion?.plannedDate),
            completionActual: formatDate(values?.completion?.actualDate),

            closeoutPlanned: formatDate(values?.closeout?.plannedDate),
            closeoutActual: formatDate(values?.closeout?.actualDate)
        };



        try {
            const response = await updateProcurement(reqBody).unwrap()
            openNotification("Procurement updated successfully", "success");
            resetForm();
            setSubmitting(false);
            handleClose();
        } catch (error) {
            openNotification(error?.error ?? "Something went wrong", "error");
        } finally {
            setSubmitting(false);
        }
    };

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    const sequenceOfFields = [
        "mobilization",
        "poIssue",
        "approval",
        "negotiationAndRecommendation",
        "commercialEvaluation",
        "technicalEvaluation",
        "bidSubmission",
        "preBidMeeting",
        "bidInvitation",
        "nttIssue",
        "rfpPreparation"
    ];

    const calculatePlannedDates = (values, setFieldValue) => {
        let previousPlannedDate = values.mobilization.plannedDate;

        sequenceOfFields.forEach((key, index) => {
            if (index === 0) return;

            const days = values[sequenceOfFields[index - 1]]?.days;

            if (previousPlannedDate && days) {
                const nextPlannedDate = moment(previousPlannedDate)
                    .subtract(Number(days), "days")
                    .format("YYYY-MM-DD");

                setFieldValue(`${key}.plannedDate`, nextPlannedDate);
                previousPlannedDate = nextPlannedDate;
            } else {
                setFieldValue(`${key}.plannedDate`, "");
                previousPlannedDate = "";
            }
        });
    };

    const renderSubTab0Fields = ({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
        <>
            <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                    Budgeted Cost (INR)
                </Typography>
                <TextField
                    fullWidth
                    name="budgetedCost"
                    value={values.budgetedCost}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter Budgeted Cost"
                    InputProps={{
                        sx: {
                            height: "40px",
                            borderRadius: "4px",
                            backgroundColor: "#fff",
                            "& input::placeholder": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#5F5F5F",
                                fontFamily: "Outfit, sans-serif",
                                opacity: 1,
                            },
                            "& input": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#0A0A0C",
                                fontFamily: "Outfit, sans-serif",
                                "&:-webkit-autofill": {
                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                    WebkitTextFillColor: "#0A0A0C",
                                },
                                "&:-webkit-autofill:hover": {
                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                    WebkitTextFillColor: "#0A0A0C",
                                },
                                "&:-webkit-autofill:focus": {
                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                    WebkitTextFillColor: "#0A0A0C",
                                },
                            },
                        },
                    }}
                />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                    Status
                </Typography>
                <Autocomplete
                    options={filteredStatusOption}
                    getOptionLabel={(option) => option?.label || ''}
                    value={
                        filteredStatusOption?.find(
                            (opt) => opt.label == values?.status
                        ) || null
                    }
                    onChange={(_, newSelected) => {
                        // const updated = newSelected.map(item => ({ roleId: item?.id }));
                        setFieldValue(
                            `status`,
                            newSelected ? newSelected.label : ""   // store only roleId string
                        );
                    }}
                    onBlur={handleBlur}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder="Select Status"
                            name={`status`}
                            size="small"
                            sx={{
                                "& input::placeholder": {
                                    fontWeight: 400,
                                    fontSize: "16px",
                                    lineHeight: "100%",
                                    letterSpacing: "0.16px",
                                    color: "#5F5F5F",
                                    fontFamily: "Outfit, sans-serif",
                                    opacity: 1,
                                },
                            }}
                        />
                    )}
                    ListboxProps={{ sx: { fontSize: '13px' } }}
                />
                {touched?.status && errors?.status &&
                    <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.status}`}</FormHelperText>
                }
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                    Planned Date of Tender Package
                </Typography>
                <TextField
                    type="date"
                    name="plannedDateOfTenderPackage"
                    value={values.plannedDateOfTenderPackage}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onClick={(e) => {
                        // Trigger the native date picker
                        const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                        if (input) input.showPicker?.();
                    }}
                    fullWidth
                    sx={{
                        ...rightTextStyle,
                        "& input::-webkit-calendar-picker-indicator": {
                            display: "none",
                            WebkitAppearance: "none",
                        },
                        "& input[type='date']": {
                            appearance: "none",
                            WebkitAppearance: "none",
                        },
                        "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                                border: "none",
                            },
                        },
                    }}
                    InputProps={{
                        startAdornment: (
                            <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                            >
                                {calenderSVG}
                            </Box>
                        ),
                        sx: {
                            backgroundColor: "#fff",
                            border: '1px solid',
                            borderColor: 'hsl(0, 0%, 80%)',
                            height: "40px",
                            width: { xs: "100%", md: "100%" },
                            borderRadius: "5px",
                        },
                    }}
                />
                {touched.plannedDateOfTenderPackage && errors.plannedDateOfTenderPackage && (
                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                        {errors.plannedDateOfTenderPackage}
                    </Typography>
                )}
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                    Actual Cost (INR)
                </Typography>
                <TextField
                    fullWidth
                    name="actualCost"
                    value={values.actualCost}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter Actual Cost"
                    InputProps={{
                        sx: {
                            height: "40px",
                            borderRadius: "4px",
                            backgroundColor: "#fff",
                            "& input::placeholder": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#5F5F5F",
                                fontFamily: "Outfit, sans-serif",
                                opacity: 1,
                            },
                            "& input": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#0A0A0C",
                                fontFamily: "Outfit, sans-serif",
                                "&:-webkit-autofill": {
                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                    WebkitTextFillColor: "#0A0A0C",
                                },
                                "&:-webkit-autofill:hover": {
                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                    WebkitTextFillColor: "#0A0A0C",
                                },
                                "&:-webkit-autofill:focus": {
                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                    WebkitTextFillColor: "#0A0A0C",
                                },
                            },
                        },
                    }}
                />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                    Actual LOI/WO Date
                </Typography>
                <TextField
                    type="date"
                    fullWidth
                    name="actualLoiWoDate"
                    value={values.actualLoiWoDate}
                    onChange={handleChange}
                    InputProps={commonInputFieldStyle}
                />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                    Vendor name
                </Typography>
                {/* <TextField
                    fullWidth
                    name="vendorName"
                    value={values.vendorName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter Vendor Name"
                    InputProps={{
                        sx: {
                            height: "40px",
                            borderRadius: "4px",
                            backgroundColor: "#fff",
                            "& input::placeholder": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#5F5F5F",
                                fontFamily: "Outfit, sans-serif",
                                opacity: 1,
                            },
                            "& input": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#0A0A0C",
                                fontFamily: "Outfit, sans-serif",
                                "&:-webkit-autofill": {
                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                    WebkitTextFillColor: "#0A0A0C",
                                },
                                "&:-webkit-autofill:hover": {
                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                    WebkitTextFillColor: "#0A0A0C",
                                },
                                "&:-webkit-autofill:focus": {
                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                    WebkitTextFillColor: "#0A0A0C",
                                },
                            },
                        },
                    }}
                /> */}
                <Autocomplete
                    options={vendorNameOption}
                    getOptionLabel={(option) => option?.label || ''}
                    value={
                        vendorNameOption?.find(
                            (opt) => opt.value == values?.vendorName
                        ) || null
                    }
                    onChange={(_, newSelected) => {
                        setFieldValue(
                            `vendorName`,
                            newSelected ? newSelected.value : ""
                        );
                    }}
                    onBlur={handleBlur}

                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder="Select Vendor Name"
                            name={`vendorName`}
                            size="small"
                            sx={{
                                "& input::placeholder": {
                                    fontWeight: 400,
                                    fontSize: "16px",
                                    lineHeight: "100%",
                                    letterSpacing: "0.16px",
                                    color: "#5F5F5F",
                                    fontFamily: "Outfit, sans-serif",
                                    opacity: 1,
                                },
                            }}
                        />
                    )}
                    ListboxProps={{ sx: { fontSize: '13px' } }}
                />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                    LOI Reference
                </Typography>
                <TextField
                    fullWidth
                    name="loiReference"
                    value={values.loiReference}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter Loi Reference"
                    InputProps={{
                        sx: {
                            height: "40px",
                            borderRadius: "4px",
                            backgroundColor: "#fff",
                            "& input::placeholder": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#5F5F5F",
                                fontFamily: "Outfit, sans-serif",
                                opacity: 1,
                            },
                            "& input": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#0A0A0C",
                                fontFamily: "Outfit, sans-serif",
                                "&:-webkit-autofill": {
                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                    WebkitTextFillColor: "#0A0A0C",
                                },
                                "&:-webkit-autofill:hover": {
                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                    WebkitTextFillColor: "#0A0A0C",
                                },
                                "&:-webkit-autofill:focus": {
                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                    WebkitTextFillColor: "#0A0A0C",
                                },
                            },
                        },
                    }}
                />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                    Select Source Department
                </Typography>
                <Autocomplete
                    options={SourceDepartmentOption}
                    getOptionLabel={(option) => option?.label || ''}
                    value={
                        SourceDepartmentOption?.find(
                            (opt) => opt.label == values?.sourceDepartment
                        ) || null
                    }
                    onChange={(_, newSelected) => {
                        // const updated = newSelected.map(item => ({ roleId: item?.id }));
                        setFieldValue(
                            `sourceDepartment`,
                            newSelected ? newSelected.label : ""   // store only roleId string
                        );
                    }}
                    onBlur={handleBlur}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder="Select Source Department"
                            name={`sourceDepartment`}
                            size="small"
                            sx={{
                                "& input::placeholder": {
                                    fontWeight: 400,
                                    fontSize: "16px",
                                    lineHeight: "100%",
                                    letterSpacing: "0.16px",
                                    color: "#5F5F5F",
                                    fontFamily: "Outfit, sans-serif",
                                    opacity: 1,
                                },
                            }}
                        />
                    )}
                    ListboxProps={{ sx: { fontSize: '13px' } }}
                />
                {touched?.sourceDepartment && errors?.sourceDepartment &&
                    <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.sourceDepartment}`}</FormHelperText>
                }
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                    Select Procurement Owner
                </Typography>
                <Autocomplete
                    options={actionResponsible}
                    getOptionLabel={(option) => option?.label || ''}
                    value={
                        actionResponsible?.find(
                            (opt) => opt.value == values?.procurementOwner
                        ) || null
                    }
                    onChange={(_, newSelected) => {
                        setFieldValue(
                            `procurementOwner`,
                            newSelected ? newSelected.value : ""
                        );
                    }}
                    onBlur={handleBlur}

                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder="Select Procurement Owner"
                            name={`procurementOwner`}
                            size="small"
                            sx={{
                                "& input::placeholder": {
                                    fontWeight: 400,
                                    fontSize: "16px",
                                    lineHeight: "100%",
                                    letterSpacing: "0.16px",
                                    color: "#5F5F5F",
                                    fontFamily: "Outfit, sans-serif",
                                    opacity: 1,
                                },
                            }}
                        />
                    )}
                    ListboxProps={{ sx: { fontSize: '13px' } }}
                />
                {touched?.procurementOwner && errors?.procurementOwner &&
                    <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.procurementOwner}`}</FormHelperText>
                }
            </Grid>

            {/* <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                    Planned Date For Service Request
                </Typography>
                <TextField
                    type="date"
                    fullWidth
                    name="plannedDateForServiceRequest"
                    value={values.plannedDateForServiceRequest}
                    onChange={handleChange}
                    InputProps={commonInputFieldStyle}
                />
            </Grid> */}

            <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                    Actual Service Request/Indent Date
                </Typography>
                <TextField
                    type="date"
                    fullWidth
                    name="actualServiceRequestIndentDate"
                    value={values.actualServiceRequestIndentDate}
                    onChange={handleChange}
                    InputProps={commonInputFieldStyle}
                />
            </Grid>

            {/* <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                    Planned Date RFP/RFQ Floating
                </Typography>
                <TextField
                    type="date"
                    fullWidth
                    name="plannedRfpRfqFloatingDate"
                    value={values.plannedRfpRfqFloatingDate}
                    onChange={handleChange}
                    InputProps={commonInputFieldStyle}
                />
            </Grid> */}

            {/* <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                    Cutoff Date For Receipt Of Bids
                </Typography>
                <TextField
                    type="date"
                    fullWidth
                    name="bidReceiptCutoffDate"
                    value={values.bidReceiptCutoffDate}
                    onChange={handleChange}
                    InputProps={commonInputFieldStyle}
                />
            </Grid> */}

            {/* <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                    Planned Date Of Release Of LOI/WO/PO
                </Typography>
                <TextField
                    type="date"
                    fullWidth
                    name="plannedLoiReleaseDate"
                    value={values.plannedLoiReleaseDate}
                    onChange={handleChange}
                    InputProps={commonInputFieldStyle}
                />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                    Planned Finish Of The Activity At Site
                </Typography>
                <TextField
                    type="date"
                    fullWidth
                    name="plannedFinishAtSiteDate"
                    value={values.plannedFinishAtSiteDate}
                    onChange={handleChange}
                    InputProps={commonInputFieldStyle}
                />
            </Grid> */}

            <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                    Lead Time (Days)
                </Typography>
                <TextField
                    type="number"
                    fullWidth
                    name="leadTimeDays"
                    value={values.leadTimeDays}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter Lead Time"
                    InputProps={{
                        sx: {
                            height: "40px",
                            borderRadius: "4px",
                            backgroundColor: "#fff",
                            "& input::placeholder": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#5F5F5F",
                                fontFamily: "Outfit, sans-serif",
                                opacity: 1,
                            },
                            "& input": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#0A0A0C",
                                fontFamily: "Outfit, sans-serif",
                            },
                        },
                    }}
                />
            </Grid>

            {/* <Grid size={{ xs: 12, md: 6 }}> */}
            {/* <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                    Mobilization Required Days Left
                </Typography>
                <TextField
                    type="number"
                    fullWidth
                    name="mobilizationRequiredDaysLeft"
                    value={values.mobilizationRequiredDaysLeft}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter Mobilization Days Left"
                    InputProps={{
                        sx: {
                            height: "40px",
                            borderRadius: "4px",
                            backgroundColor: "#fff",
                            "& input::placeholder": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#5F5F5F",
                                fontFamily: "Outfit, sans-serif",
                                opacity: 1,
                            },
                            "& input": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#0A0A0C",
                                fontFamily: "Outfit, sans-serif",
                            },
                        },
                    }}
                />
            </Grid> */}

            <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                    Last Updated Date
                </Typography>
                <TextField
                    type="date"
                    fullWidth
                    name="lastUpdatedDate"
                    value={values.lastUpdatedDate}
                    onChange={handleChange}
                    InputProps={commonInputFieldStyle}
                />
            </Grid>

            {/* <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                    Status
                </Typography>
                <TextField
                    fullWidth
                    name="status"
                    value={values.status}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter Status"
                    InputProps={{
                        sx: {
                            height: "40px",
                            borderRadius: "4px",
                            backgroundColor: "#fff",
                            "& input::placeholder": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#5F5F5F",
                                fontFamily: "Outfit, sans-serif",
                                opacity: 1,
                            },
                            "& input": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#0A0A0C",
                                fontFamily: "Outfit, sans-serif",
                            },
                        },
                    }}
                />
            </Grid> */}

            <Grid size={{ xs: 12, md: 12 }}>
                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                    Remarks / Notes
                </Typography>
                <TextField
                    fullWidth
                    name="remark"
                    value={values.remark}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    multiline
                    rows={3}
                    placeholder="Enter Remarks / Notes"
                    InputProps={{
                        sx: {
                            borderRadius: "8px",
                            backgroundColor: "#fff",
                            "& textarea::placeholder": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#0A0A0C",
                                fontFamily: "Outfit, sans-serif",
                                opacity: 1,
                            },
                            "& textarea": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#0A0A0C",
                                fontFamily: "Outfit, sans-serif",
                            },
                        },
                    }}
                />
            </Grid>
        </>
    );

    const renderSubTab1Fields = ({ values, handleChange, handleBlur, setFieldValue, touched, errors }) => (
        <>
            <Grid size={{ xs: 12, md: 12 }}>
                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                    Sub Project
                </Typography>
                <TextField
                    fullWidth
                    name="subProject"
                    value={values.subProject}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter Sub Project"
                    InputProps={{
                        sx: {
                            height: "40px",
                            borderRadius: "4px",
                            backgroundColor: "#fff",
                            "& input::placeholder": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#5F5F5F",
                                fontFamily: "Outfit, sans-serif",
                                opacity: 1,
                            },
                            "& input": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#0A0A0C",
                                fontFamily: "Outfit, sans-serif",
                            },
                        },
                    }}
                />
                {touched?.subProject && errors?.subProject && (
                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                        {errors?.subProject}
                    </Typography>
                )}
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                    Select Service Category
                </Typography>
                <Autocomplete
                    options={serviceCategoryOption}
                    getOptionLabel={(option) => option?.label || ''}
                    value={
                        serviceCategoryOption?.find(
                            (opt) => opt.label == values?.serviceCategory
                        ) || null
                    }
                    onChange={(_, newSelected) => {
                        setFieldValue(
                            `serviceCategory`,
                            newSelected ? newSelected.label : ""
                        );
                    }}
                    onBlur={handleBlur}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder="Select Service Category"
                            name={`serviceCategory`}
                            size="small"
                            sx={{
                                "& input::placeholder": {
                                    fontWeight: 400,
                                    fontSize: "16px",
                                    lineHeight: "100%",
                                    letterSpacing: "0.16px",
                                    color: "#5F5F5F",
                                    fontFamily: "Outfit, sans-serif",
                                    opacity: 1,
                                },
                            }}
                        />
                    )}
                    ListboxProps={{ sx: { fontSize: '13px' } }}
                />
                {touched?.serviceCategory && errors?.serviceCategory &&
                    <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.serviceCategory}`}</FormHelperText>
                }
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                    Select Procurement Method
                </Typography>
                <Autocomplete
                    options={procurementMethodOption}
                    getOptionLabel={(option) => option?.label || ''}
                    value={
                        procurementMethodOption?.find(
                            (opt) => opt.label == values?.procurementMethod
                        ) || null
                    }
                    onChange={(_, newSelected) => {
                        setFieldValue(
                            `procurementMethod`,
                            newSelected ? newSelected.label : ""
                        );
                    }}
                    onBlur={handleBlur}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder="Select Procurement Method"
                            name={`procurementMethod`}
                            size="small"
                            sx={{
                                "& input::placeholder": {
                                    fontWeight: 400,
                                    fontSize: "16px",
                                    lineHeight: "100%",
                                    letterSpacing: "0.16px",
                                    color: "#5F5F5F",
                                    fontFamily: "Outfit, sans-serif",
                                    opacity: 1,
                                },
                            }}
                        />
                    )}
                    ListboxProps={{ sx: { fontSize: '13px' } }}
                />
                {touched?.procurementMethod && errors?.procurementMethod &&
                    <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.procurementMethod}`}</FormHelperText>
                }
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={labelTextStyle}>Package Description</Typography>
                <TextField
                    fullWidth
                    name="packageDescription"
                    value={values.packageDescription}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    multiline
                    rows={3}
                    placeholder="Enter Package Description"
                    InputProps={{
                        sx: {
                            borderRadius: "8px",
                            backgroundColor: "#fff",

                            "& input::placeholder": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#0A0A0C",
                                fontFamily: "Outfit, sans-serif",
                                opacity: 1,
                            },

                            "& input": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#0A0A0C",
                                fontFamily: "Outfit, sans-serif",
                            },
                        },
                    }}
                />
                {touched.packageDescription && errors.packageDescription && (
                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                        {errors.packageDescription}
                    </Typography>
                )}
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={labelTextStyle}>Scope Summary</Typography>
                <TextField
                    fullWidth
                    name="scopeSummary"
                    value={values.scopeSummary}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    multiline
                    rows={3}
                    placeholder="Enter Scope Summary"
                    InputProps={{
                        sx: {
                            borderRadius: "8px",
                            backgroundColor: "#fff",

                            "& input::placeholder": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#0A0A0C",
                                fontFamily: "Outfit, sans-serif",
                                opacity: 1,
                            },

                            "& input": {
                                fontWeight: 400,
                                fontSize: "16px",
                                lineHeight: "100%",
                                letterSpacing: "0.16px",
                                color: "#0A0A0C",
                                fontFamily: "Outfit, sans-serif",
                            },
                        },
                    }}
                />
                {touched.scopeSummary && errors.scopeSummary && (
                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                        {errors.scopeSummary}
                    </Typography>
                )}
            </Grid>

            <Grid container spacing={2} size={12}>
                <Grid size={12} sx={{ mb: -2.5 }}>
                    <Typography sx={labelTextStyle}>Mobilization</Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Planned Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="mobilization.plannedDate"
                        value={values.mobilization.plannedDate}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    mobilization: {
                                        ...values.mobilization,
                                        plannedDate: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        // onBlur={() => calculatePlannedDates(values, setFieldValue)}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Days</Typography>
                    <TextField
                        type="number"
                        fullWidth
                        name="mobilization.days"
                        value={values.mobilization.days}

                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    mobilization: {
                                        ...values.mobilization,
                                        days: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        //onBlur={() => calculatePlannedDates(values, setFieldValue)}
                        onBlur={handleBlur}

                        InputProps={commonInputFieldStyle}
                    />
                    {touched.mobilization?.days && errors.mobilization?.days && (
                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                            {errors.mobilization?.days}
                        </Typography>
                    )}

                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Actual Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="mobilization.actualDate"
                        value={values.mobilization.actualDate}
                        onChange={handleChange}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>
            </Grid>

            {values.mobilization.plannedDate && values.mobilization.days > 0 && <Grid container spacing={2} size={12}>
                <Grid size={12} sx={{ mb: -2.5 }}>
                    <Typography sx={labelTextStyle}>PO/LOA Issue</Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Planned Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="poIssue.plannedDate"
                        value={values.poIssue.plannedDate}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    poIssue: {
                                        ...values.poIssue,
                                        plannedDate: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        //onBlur={() => calculatePlannedDates(values, setFieldValue)}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Days</Typography>
                    <TextField
                        type="number"
                        fullWidth
                        name="poIssue.days"
                        value={values.poIssue.days}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    poIssue: {
                                        ...values.poIssue,
                                        days: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        onBlur={handleBlur}
                        //onBlur={() => calculatePlannedDates(values, setFieldValue)}
                        InputProps={commonInputFieldStyle}
                    />
                    {touched.poIssue?.days && errors.poIssue?.days && (
                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                            {errors.poIssue?.days}
                        </Typography>
                    )}
                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Actual Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="poIssue.actualDate"
                        value={values.poIssue.actualDate}
                        onChange={handleChange}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>
            </Grid>}

            {values.poIssue.plannedDate && values.poIssue.days > 0 && <Grid container spacing={2} size={12}>
                <Grid size={12} sx={{ mb: -2.5 }}>
                    <Typography sx={labelTextStyle}>Approval</Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Planned Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="approval.plannedDate"
                        value={values.approval.plannedDate}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    approval: {
                                        ...values.approval,
                                        plannedDate: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        //onBlur={() => calculatePlannedDates(values, setFieldValue)}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Days</Typography>
                    <TextField
                        type="number"
                        fullWidth
                        name="approval.days"
                        value={values.approval.days}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    approval: {
                                        ...values.approval,
                                        days: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        onBlur={handleBlur}
                        //onBlur={() => calculatePlannedDates(values, setFieldValue)}
                        InputProps={commonInputFieldStyle}
                    />
                    {touched.approval?.days && errors.approval?.days && (
                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                            {errors.approval?.days}
                        </Typography>
                    )}
                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Actual Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="approval.actualDate"
                        value={values.approval.actualDate}
                        onChange={handleChange}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>
            </Grid>}

            {values.approval.plannedDate && values.approval.days > 0 && <Grid container spacing={2} size={12}>
                <Grid size={12} sx={{ mb: -2.5 }}>
                    <Typography sx={labelTextStyle}>Negotiation & Recommendation</Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Planned Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="negotiationAndRecommendation.plannedDate"
                        value={values.negotiationAndRecommendation.plannedDate}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    negotiationAndRecommendation: {
                                        ...values.negotiationAndRecommendation,
                                        plannedDate: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Days</Typography>
                    <TextField
                        type="number"
                        fullWidth
                        name="negotiationAndRecommendation.days"
                        value={values.negotiationAndRecommendation.days}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    negotiationAndRecommendation: {
                                        ...values.negotiationAndRecommendation,
                                        days: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        onBlur={handleBlur}
                        InputProps={commonInputFieldStyle}
                    />
                    {touched.negotiationAndRecommendation?.days && errors.negotiationAndRecommendation?.days && (
                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                            {errors.negotiationAndRecommendation?.days}
                        </Typography>
                    )}
                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Actual Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="negotiationAndRecommendation.actualDate"
                        value={values.negotiationAndRecommendation.actualDate}
                        onChange={handleChange}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>
            </Grid>}

            {values.negotiationAndRecommendation.plannedDate && values.negotiationAndRecommendation.days > 0 && <Grid container spacing={2} size={12}>
                <Grid size={12} sx={{ mb: -2.5 }}>
                    <Typography sx={labelTextStyle}>Commercial Evaluation</Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Planned Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="commercialEvaluation.plannedDate"
                        value={values.commercialEvaluation.plannedDate}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    commercialEvaluation: {
                                        ...values.commercialEvaluation,
                                        plannedDate: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Days</Typography>
                    <TextField
                        type="number"
                        fullWidth
                        name="commercialEvaluation.days"
                        value={values.commercialEvaluation.days}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    commercialEvaluation: {
                                        ...values.commercialEvaluation,
                                        days: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        onBlur={handleBlur}
                        InputProps={commonInputFieldStyle}
                    />
                    {touched.commercialEvaluation?.days && errors.commercialEvaluation?.days && (
                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                            {errors.commercialEvaluation?.days}
                        </Typography>
                    )}
                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Actual Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="commercialEvaluation.actualDate"
                        value={values.commercialEvaluation.actualDate}
                        onChange={handleChange}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>
            </Grid>}

            {values.commercialEvaluation.plannedDate && values.commercialEvaluation.days > 0 && <Grid container spacing={2} size={12}>
                <Grid size={12} sx={{ mb: -2.5 }}>
                    <Typography sx={labelTextStyle}>Technical Evaluation</Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Planned Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="technicalEvaluation.plannedDate"
                        value={values.technicalEvaluation.plannedDate}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    technicalEvaluation: {
                                        ...values.technicalEvaluation,
                                        plannedDate: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Days</Typography>
                    <TextField
                        type="number"
                        fullWidth
                        name="technicalEvaluation.days"
                        value={values.technicalEvaluation.days}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    technicalEvaluation: {
                                        ...values.technicalEvaluation,
                                        days: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        onBlur={handleBlur}
                        InputProps={commonInputFieldStyle}
                    />
                    {touched.technicalEvaluation?.days && errors.technicalEvaluation?.days && (
                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                            {errors.technicalEvaluation?.days}
                        </Typography>
                    )}
                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Actual Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="technicalEvaluation.actualDate"
                        value={values.technicalEvaluation.actualDate}
                        onChange={handleChange}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>
            </Grid>}

            {values.technicalEvaluation.plannedDate && values.technicalEvaluation.days > 0 && <Grid container spacing={2} size={12}>
                <Grid size={12} sx={{ mb: -2.5 }}>
                    <Typography sx={labelTextStyle}>Bid Submission</Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Planned Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="bidSubmission.plannedDate"
                        value={values.bidSubmission.plannedDate}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    bidSubmission: {
                                        ...values.bidSubmission,
                                        plannedDate: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Days</Typography>
                    <TextField
                        type="number"
                        fullWidth
                        name="bidSubmission.days"
                        value={values.bidSubmission.days}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    bidSubmission: {
                                        ...values.bidSubmission,
                                        days: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        onBlur={handleBlur}
                        InputProps={commonInputFieldStyle}
                    />
                    {touched.bidSubmission?.days && errors.bidSubmission?.days && (
                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                            {errors.bidSubmission?.days}
                        </Typography>
                    )}
                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Actual Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="bidSubmission.actualDate"
                        value={values.bidSubmission.actualDate}
                        onChange={handleChange}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>
            </Grid>}

            {values.bidSubmission.plannedDate && values.bidSubmission.days > 0 && <Grid container spacing={2} size={12}>
                <Grid size={12} sx={{ mb: -2.5 }}>
                    <Typography sx={labelTextStyle}>Pre Bid Meeting</Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Planned Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="preBidMeeting.plannedDate"
                        value={values.preBidMeeting.plannedDate}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    preBidMeeting: {
                                        ...values.preBidMeeting,
                                        plannedDate: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Days</Typography>
                    <TextField
                        type="number"
                        fullWidth
                        name="preBidMeeting.days"
                        value={values.preBidMeeting.days}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    preBidMeeting: {
                                        ...values.preBidMeeting,
                                        days: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        onBlur={handleBlur}
                        InputProps={commonInputFieldStyle}
                    />
                    {touched.preBidMeeting?.days && errors.preBidMeeting?.days && (
                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                            {errors.preBidMeeting?.days}
                        </Typography>
                    )}
                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Actual Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="preBidMeeting.actualDate"
                        value={values.preBidMeeting.actualDate}
                        onChange={handleChange}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>
            </Grid>}

            {values.preBidMeeting.plannedDate && values.preBidMeeting.days > 0 && <Grid container spacing={2} size={12}>
                <Grid size={12} sx={{ mb: -2.5 }}>
                    <Typography sx={labelTextStyle}>Bid Invitation/RFQ</Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Planned Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="bidInvitation.plannedDate"
                        value={values.bidInvitation.plannedDate}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    bidInvitation: {
                                        ...values.bidInvitation,
                                        plannedDate: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        InputProps={commonInputFieldStyle}
                    />

                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Days</Typography>
                    <TextField
                        type="number"
                        fullWidth
                        name="bidInvitation.days"
                        value={values.bidInvitation.days}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    bidInvitation: {
                                        ...values.bidInvitation,
                                        days: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        onBlur={handleBlur}
                        InputProps={commonInputFieldStyle}
                    />
                    {touched.bidInvitation?.days && errors.bidInvitation?.days && (
                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                            {errors.bidInvitation?.days}
                        </Typography>
                    )}
                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Actual Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="bidInvitation.actualDate"
                        value={values.bidInvitation.actualDate}
                        onChange={handleChange}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>
            </Grid>}



            {values.bidInvitation.plannedDate && values.bidInvitation.days > 0 && <Grid container spacing={2} size={12}>
                <Grid size={12} sx={{ mb: -2.5 }}>
                    <Typography sx={labelTextStyle}>NTT Issue</Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Planned Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="nttIssue.plannedDate"
                        value={values.nttIssue.plannedDate}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    nttIssue: {
                                        ...values.nttIssue,
                                        plannedDate: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Days</Typography>
                    <TextField
                        type="number"
                        fullWidth
                        name="nttIssue.days"
                        value={values.nttIssue.days}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    nttIssue: {
                                        ...values.nttIssue,
                                        days: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        onBlur={handleBlur}
                        InputProps={commonInputFieldStyle}
                    />
                    {touched.nttIssue?.days && errors.nttIssue?.days && (
                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                            {errors.nttIssue?.days}
                        </Typography>
                    )}
                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Actual Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="nttIssue.actualDate"
                        value={values.nttIssue.actualDate}
                        onChange={handleChange}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>
            </Grid>}

            {values.nttIssue.plannedDate && values.nttIssue.days > 0 && <Grid container spacing={2} size={12}>
                <Grid size={12} sx={{ mb: -2.5 }}>
                    <Typography sx={labelTextStyle}>RFP/RFQ Preparation</Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Planned Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="rfpPreparation.plannedDate"
                        value={values.rfpPreparation.plannedDate}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    rfpPreparation: {
                                        ...values.rfpPreparation,
                                        plannedDate: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Days</Typography>
                    <TextField
                        type="number"
                        fullWidth
                        name="rfpPreparation.days"
                        value={values.rfpPreparation.days}
                        onChange={(e) => {
                            handleChange(e);
                            calculatePlannedDates(
                                {
                                    ...values,
                                    rfpPreparation: {
                                        ...values.rfpPreparation,
                                        days: e.target.value
                                    }
                                },
                                setFieldValue
                            );
                        }}
                        onBlur={handleBlur}
                        InputProps={commonInputFieldStyle}
                    />
                    {touched.rfpPreparation?.days && errors.rfpPreparation?.days && (
                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                            {errors.rfpPreparation?.days}
                        </Typography>
                    )}
                </Grid>


                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography sx={labelTextStyle}>Actual Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="rfpPreparation.actualDate"
                        value={values.rfpPreparation.actualDate}
                        onChange={handleChange}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>
            </Grid>}

            <Grid container spacing={2} size={12}>
                <Grid size={12} sx={{ mb: -2.5 }}>
                    <Typography sx={labelTextStyle}>Completion</Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Typography sx={labelTextStyle}>Planned Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="completion.plannedDate"
                        value={values.completion.plannedDate}
                        onChange={handleChange}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                    <Typography sx={labelTextStyle}>Actual Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="completion.actualDate"
                        value={values.completion.actualDate}
                        onChange={handleChange}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>
            </Grid>

            {/* <Grid container spacing={2} size={12}>
                <Grid size={12} sx={{ mb: -2.5 }}>
                    <Typography sx={labelTextStyle}>Closeout</Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Typography sx={labelTextStyle}>Planned Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="closeout.plannedDate"
                        value={values.closeout.plannedDate}
                        onChange={handleChange}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                    <Typography sx={labelTextStyle}>Actual Date</Typography>
                    <TextField
                        type="date"
                        fullWidth
                        name="closeout.actualDate"
                        value={values.closeout.actualDate}
                        onChange={handleChange}
                        InputProps={commonInputFieldStyle}
                    />
                </Grid>
            </Grid> */}
        </>
    );

    return (
        <Dialog open={open}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >

            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
                position: "relative",
            }}>
                <Typography sx={{
                    fontWeight: 600,
                    fontSize: "27px",
                    lineHeight: "100%",
                    color: "#140F36",
                    fontFamily: "Outfit, sans-serif"
                }}>
                    Edit Procurement HotelSitc
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 50,
                        top: 8,
                        color: theme.palette.grey[500],

                    })}
                >
                    <RxCross2 size={30} color="#140F36" />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container>

                    <Grid size={{ md: 12, xs: 12 }}>
                        <Formik
                            initialValues={initialFormData}
                            validationSchema={validationSchema}
                            onSubmit={handleSitcSubmit}
                            enableReinitialize
                        >
                            {({ values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting,
                                setFieldValue,
                                setFieldTouched,
                                setTouched, }) => (
                                <form onSubmit={handleSubmit}>
                                    <Grid container spacing={2}>
                                        {(subTabValue === "summary" || subTabValue === "Procurement Plan - Hotel Sitc") && renderSubTab0Fields({ values, errors, touched, handleChange, handleBlur, setFieldValue })}
                                        {subTabValue === "detail" && renderSubTab1Fields({ values, handleChange, handleBlur, setFieldValue, touched, errors })}

                                        <Grid size={12}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <Button onClick={handleClose}
                                                    sx={{
                                                        textTransform: "none",
                                                        color: "#F15744",
                                                        fontSize: "14px",
                                                        lineHeight: "100%",
                                                        fontFamily: "Outfit, sans-serif",
                                                        borderRadius: "25px",
                                                        fontWeight: 500,
                                                        px: "20px",
                                                        py: "15px",
                                                    }}>
                                                    Cancel
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    sx={{
                                                        backgroundColor: "#00344C",
                                                        borderRadius: "25px",
                                                        textTransform: "none",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        lineHeight: "100%",
                                                        fontFamily: "Outfit, sans-serif",
                                                        color: "#FFFFFF",
                                                        px: "20px",
                                                        py: "15px",
                                                    }}
                                                >
                                                    Update
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </form>
                            )}
                        </Formik>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog >
    );
};

export default EditHotelSitc;